import API from 'config/api'

export const postResult = async (body) => {
  try {
    const response = await API.post('/result', body)
    return response
  } catch (error) {
    return error
  }
}
export const MailTaquilla = async (body) => {
  try {
    const response = await API.post('/activity/send-email-taquilla', body)
    return response
  } catch (error) {
    return error
  }
}
export const MailDulceria = async (body) => {
  try {
    const response = await API.post('/activity/send-email-dulceria', body)
    return response
  } catch (error) {
    return error
  }
}
